import { Show, useForm } from "@refinedev/antd";
import {
  Button,
  Col,
  DatePicker,
  Flex,
  Form,
  Input,
  Row,
  Select,
  Space,
} from "antd";
import { v4 as randomId } from "uuid";

import {
  DayMonthYear,
  errorNotification,
  successNotification,
} from "../../helpers";
import {
  AppImageUploader,
  AppRichText,
  AppTitle,
  AppViewCard,
  EFileTypes,
  richTextTemplate,
} from "../../components";
import { LeagueStaffType } from "../Leagues/Lib";
import { noSpecialCharValidator } from "../../validators";
import { useNavigation } from "@refinedev/core";
import {
  AppAudioUploader,
  EAudioFileTypes,
} from "../../components/App-Audio-Uploader/AppAudioUploader";
export const CommentatorsCreate = () => {
  const { push } = useNavigation();

  const { formProps, saveButtonProps, form, formLoading, onFinish } =
    useForm<LeagueStaffType>({
      resource: "commentators",
      action: "create",
      dataProviderName: "commentatorsDataProvider",
      redirect: false,
      ...successNotification({
        successData: {
          message: "Комментатор добавлен",
          type: "success",
        },
        callback: () => push("/commentators"),
      }),
      ...errorNotification({}),
    });

  // Обработчик отправки формы с преобразованием полей
  const handleFinish = async (values: any) => {
    const formattedValues = {
      firstName: values.firstName,
      lastName: values.lastName,
      patronymic: values.patronymic,
      youtube_link: values.youtube_link,
      vk_link: values.vk_link,
      tg_link: values.tg_link,
      photo: values.photo,
      birthdate: values.birthday
        ? values.birthday.format("YYYY-MM-DDTHH:mm:ss")
        : null,
      city: values.city,
      spec: values.spec,
      voice: values.voice,
      about: values.about,
    };

    return onFinish(formattedValues);
  };
  const spicealisation = [
    {
      value: 100,
      label: "Лига PARI",
    },
    {
      value: 200,
      label: "LEON-Вторая лига А",
    },
    {
      value: 300,
      label: "LEON-Вторая лига Б",
    },
  ];
  return (
    <Show
      title={<AppTitle canGoBack>Добавить комментатора</AppTitle>}
      breadcrumb={false}
      footerButtons={null}
      goBack={false}
      headerButtons={<></>}
    >
      <Form {...formProps} layout={"vertical"} onFinish={handleFinish}>
        <Row gutter={24}>
          <Col span={12}>
            <Flex gap={"small"}>
              <AppViewCard label={"Фото"} style={{ flexGrow: 1 }}>
                <Form.Item
                  name={"photo"}
                  rules={[
                    {
                      required: true,
                      message: "Загрузите фото комментатора",
                    },
                  ]}
                >
                  <AppImageUploader
                    type="STAFF"
                    entityId={`${randomId()}`}
                    serviceType={EFileTypes.PARTNERS}
                    cropperProps={{
                      modalTitle: "Редактировать фото",
                    }}
                    uploadProps={{
                      multiple: false,
                      children: "Фото комментатора",
                      listType: "picture-card",
                    }}
                  />
                </Form.Item>
              </AppViewCard>
            </Flex>

            <Form.Item
              name={"lastName"}
              label={"Фамилия:"}
              rules={[
                {
                  required: true,
                  message: "Необходимо указать фамилию",
                },
                noSpecialCharValidator,
              ]}
            >
              <Input placeholder={"Укажите фамилию"} />
            </Form.Item>

            <Form.Item
              name={"firstName"}
              label={"Имя:"}
              rules={[
                {
                  required: true,
                  message: "Необходимо указать имя",
                },
                noSpecialCharValidator,
              ]}
            >
              <Input placeholder={"Укажите имя"} />
            </Form.Item>

            <Form.Item
              name={"patronymic"}
              label={"Отчество:"}
              rules={[noSpecialCharValidator]}
            >
              <Input placeholder={"Укажите отчество (необязательно)"} />
            </Form.Item>

            <Form.Item
              name={"birthday"}
              label={"Дата рождения"}
              rules={[
                {
                  required: true,
                  message: "Необходимо указать дату рождения",
                },
              ]}
            >
              <DatePicker
                allowClear={false}
                format={DayMonthYear}
                style={{ width: "100%" }}
                placeholder={"Дата рождения"}
              />
            </Form.Item>

            <Form.Item
              name={"city"}
              label={"Город:"}
              rules={[
                {
                  required: true,
                  message: "Необходимо указать город",
                },
              ]}
            >
              <Input placeholder={"Укажите город"} />
            </Form.Item>
            <Form.Item
              name={"vk_link"}
              label={"Ссылка Vk:"}
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input placeholder={"Укажите vk"} />
            </Form.Item>
            <Form.Item
              name={"youtube_link"}
              label={"Ссылка Youtube:"}
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input placeholder={"Укажите Youtube"} />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: false,
                },
              ]}
              name={"tg_link"}
              label={"Ссылка телеграм:"}
            >
              <Input placeholder={"Укажите телеграм"} />
            </Form.Item>
            <Form.Item
              name={"spec"}
              label={
                <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                  Специализации{" "}
                </div>
              }
            >
              <Select
                placeholder={"Укажите специализацию"}
                showSearch
                mode={"multiple"}
                options={spicealisation}
                notFoundContent={
                  <div
                    style={{
                      width: "100%",
                      height: 100,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Укажите специализацию
                  </div>
                }
              />
            </Form.Item>
            {/*<Form.Item*/}
            {/*  name={"category"}*/}
            {/*  label={"Специализация:"}*/}
            {/*  rules={[*/}
            {/*    {*/}
            {/*      required: true,*/}
            {/*      message: "Необходимо указать специализацию",*/}
            {/*    },*/}
            {/*  ]}*/}
            {/*>*/}
            {/*  <Select placeholder="Выберите специализацию">*/}
            {/*    <Select.Option value="Лига PARI">Лига PARI</Select.Option>*/}
            {/*    <Select.Option value="LEON-Вторая лига А">*/}
            {/*      LEON-Вторая лига А*/}
            {/*    </Select.Option>*/}
            {/*    <Select.Option value="LEON-Вторая лига Б">*/}
            {/*      LEON-Вторая лига Б*/}
            {/*    </Select.Option>*/}
            {/*  </Select>*/}
            {/*</Form.Item>*/}
            <AppViewCard label={"Голос (аудио)"} style={{ flexGrow: 1 }}>
              <Form.Item name={"voice"}>
                <AppAudioUploader
                  type="MATCH"
                  entityId={`${randomId()}`}
                  serviceType={EAudioFileTypes.COMMENTATORS}
                  uploadProps={{
                    multiple: false,
                    children: "Аудио комментатора",
                  }}
                  maxFileSizeMB={20}
                />
              </Form.Item>
            </AppViewCard>
          </Col>

          <Col span={12}>
            <Form.Item name={"about"} label={"Биография:"}>
              <AppRichText
                editorTemplate={richTextTemplate.backofficeNews}
                richTextProps={{
                  placeholder: "Укажите биографию комментатора",
                  setOptions: {
                    buttonList: richTextTemplate.backofficeNews,
                    font: ["TT Norms Pro", "TT Runs"],
                    colorList: ["#FFFFFF", "#F6F6F6", "#9EA8B4", "#5D636A"],
                    linkProtocol: "https://",
                    linkRelDefault: { default: "no-follow" },
                    defaultStyle:
                      "font-family: TT Norms Pro, sans-serif; background-color: #383838; color: #FFFFFF; font-size: 16px;",
                    fontSize: [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
                  },
                }}
              />
            </Form.Item>
          </Col>

          <Space style={{ marginTop: 16 }}>
            <Button type={"primary"} htmlType={"submit"} loading={formLoading}>
              {"Добавить комментатора"}
            </Button>
          </Space>
        </Row>
      </Form>
    </Show>
  );
};
